export const defaultSearchProviderFullName = "The Search Bureau";
export const defaultSearchProviderPortalUrl = "https://searchbureau.elantechnologygroup.co.uk/app/conveyancing/new";
export const defaultSearchDbEnum = "searchbureau";